<svelte:options accessors/>
<script>
    import {getFormatter, getSubtotal, getTotal} from "../../../utils";
    import {createEventDispatcher} from "svelte";
    import NauiExplorer from "../../../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import NauiTag from "../../../naui/atoms/NauiTag.svelte";
    import NauiSlideOver from "../../../naui/layout/NauiSlideOver.svelte";
    import NauiTable from "../../../naui/components/NauiTable.svelte";
    import Margen from "./Margen.svelte";

    export let data;
    export let columns;
    export let margin = 30;

    let open = false;
    let dispatch = createEventDispatcher();
    let formatter = getFormatter();

    $: marginPercent = (margin / 100) + 1;
    $: enabled = data ? data.filter(d => d.quantity > 0) : [];
    $: subtotal = getSubtotal(enabled) * marginPercent;
    $: total = getTotal(enabled) * marginPercent;
    $: labelSubtotal = `Subtotal sin IVA | ${formatter(subtotal)}`;
    $: labelTotal = `Subtotal con IVA | ${formatter(total)}`;
    $: summaryData = setEnabled(data);

    let enabledColumns = [
        {
            slug: 'name',
            label: 'Materiales',
            type: 'text',
            order: false
        },
        {
            slug: 'quantity',
            label: 'Cantidad',
            type: 'text',
            order: false
        },
        {
            slug: 'value',
            label: 'Valor',
            type: 'text',
            order: false
        },
        {
            slug: 'actions',
            label: '',
            type: 'actions',
            order: false
        }
    ];

    function showImages() {

    }

    function changeData(ev) {
        const item = ev.detail.item;
        item.quantity = ev.detail.data;
        data = data;
    }

    function setEnabled(d) {
        const sData = [];
        if (!d) {
            return sData;
        }
        for (const item of d) {
            if (item.quantity <= 0) {
                continue;
            }
            sData.push({
                ref: item,
                name: item.name,
                slug: item.slug,
                value: formatter(item.quantity * item.price),
                quantity: item.quantity,
                actions: item.actions
            });
        }
        return sData;
    }

    function removeItem(ev) {
        ev.detail.item.ref.quantity = 0;
        data = data;
    }

    function save() {
        dispatch('save', {data});
    }
</script>

<div>
    <NauiExplorer {data} {columns} hideSearch={true} paginate={false} on:action={changeData}>
        <div slot="actions">
            <div class="box-l sx-15">
                <div class="box-l sx-1 max-w-400px">
                    <Margen type="transport" bind:margin={margin} on:changemargin/>
                </div>
                <div class="grid grid-4 gap-ii">
                    <NauiButton on:click={() => {open = true}} caption="AGREGAR A LA COTIZACIÓN" mode="stroked" icon="plus"/>
                    <NauiButton on:click={showImages} caption="VER IMAGES DEL SERVICIO" icon="image" mode="accent"/>
                    <NauiTag label={labelSubtotal}/>
                    <NauiTag label={labelTotal}/>
                </div>
            </div>
        </div>
    </NauiExplorer>
    <div class="p-1">
        <NauiButton on:click={() => {open = true}} caption="AGREGAR A LA COTIZACIÓN" mode="stroked" icon="plus"/>
    </div>
</div>

<NauiSlideOver bind:open={open} title="TOTAL LOGÍSTICA" maxWidth="400px">
    <NauiTable data={summaryData} columns={enabledColumns} on:action={removeItem}/>
    <div class="py-15">
        <h2 class="accent text-c w-100">{labelSubtotal}</h2>
        <h2 class="accent text-c w-100">{labelTotal}</h2>
    </div>
    <NauiButton on:click={save}
                color="accent"
                mode="solid"
                caption="AGREGAR A LA COTIZACIÓN"/>
</NauiSlideOver>